import {
  MRT_GlobalFilterTextField,
  MaterialReactTable,
  type MRT_ColumnDef,
  useMaterialReactTable,
} from 'material-react-table';
import { Box, Button, lighten, Stack } from '@mui/material';
import { RemoveRedEye } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import CurrencyFormat from '@/utils/CurrencyFormat';

type Person = {
  id: string;
  nome: string;
  percentual_inadimplencia: number;
  valor_pago: number;
  valor_vencido: number;
};

const columns: Array<MRT_ColumnDef<Person>> = [
    {
      accessorKey: 'nome',
      header: 'Aluno',
      sortDescFirst: true,
      enableGlobalFilter: true,
      enableMultiSort: true,
      Cell: ({ renderedCellValue }) => {
        return <div style={{ marginLeft: '20px' }}>{renderedCellValue}</div>;
      },
    },
    {
      accessorKey: 'percentual_inadimplencia',
      header: 'Inadimplência total',
      Cell: ({ renderedCellValue }) => {
        return <div style={{ marginLeft: '20px' }}>{Number(renderedCellValue).toFixed(2)} %</div>;
      },
    },
    {
      accessorKey: 'valor_pago',
      header: 'Valor pago',
      Cell: ({ renderedCellValue }) => (
        <Box
          sx={{
            backgroundColor: 'rgba(206, 250, 206, 1)',
            height: '60px',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
         {`R$ ${CurrencyFormat.formatNumber(Number(renderedCellValue))}`}
        </Box>
      ),
    },
    {
      accessorKey: 'valor_vencido',
      header: 'Valor vencido',
      Cell: ({ renderedCellValue }) => (
        <Box
          sx={{
            backgroundColor: 'rgba(252, 228, 212, 1)',
            height: '60px',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {`R$ ${CurrencyFormat.formatNumber(Number(renderedCellValue))}`}
        </Box>
      ),
    },
   
  ];

type TableHeaderCustomProps = {
  data: Person[];
  toBack: string;
};

const TableHeaderCustom = ({ data, toBack }: TableHeaderCustomProps) => {
  const navigate = useNavigate();
  const tableBasic = useMaterialReactTable({
    columns,
    data,
    enableGlobalFilter: true,
    positionActionsColumn: 'last',
    enableColumnFilterModes: false,
    enableColumnOrdering: false,
    enableGrouping: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnFilters: false,
    enableHiding: false,
    enableExpandAll: false,
    enableRowDragging: false,
    enableColumnActions: false,
    enableRowActions: true,
    enableRowSelection: false,
    enableBottomToolbar: false,
    localization: {
      search: 'Pesquisar por nome do aluno',
      actions: 'Ações', 
    },
    initialState: {
      showGlobalFilter: true, 
    },
    paginationDisplayMode: 'default',
    enablePagination: false,
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      variant: 'outlined',
      size: 'small',
      fullWidth: true,                
      placeholder: 'Pesquisar por nome…',
    },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [10, 20, 30],
      shape: 'rounded',
      variant: 'outlined',
    },
    renderRowActions: ({ row }) => {
      const handleClick = () => {
        const id = row.original.id; 
        const name = row.original.nome
        navigate(toBack, { state: { id, name } }); 
      };
    
      return (
        <Stack alignItems={'center'}>
          <RemoveRedEye
            sx={{
              cursor: 'pointer'
            }}
            onClick={handleClick} />
        </Stack>
      );
    },
    muiTableHeadCellProps: () => ({
      sx: {
        backgroundColor: 'rgb(247, 247, 247)',
        color: 'black',
        fontWeight: 400,
        fontSize: '12px',
      },
    }),
    muiTableBodyCellProps: () => ({
      sx: {
        backgroundColor: '#fff',
        color: 'rgba(128, 128, 128, 1)',
        fontWeight: 400,
        fontSize: '12px',
        padding: '0',
      },
    }),
    renderTopToolbar: ({ table }) => (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={1}
      >
        {/* LEFT‑aligned, full width filter */}
        <Box flexGrow={6} mr={2}>
          <MRT_GlobalFilterTextField
            table={table}
            //@ts-ignore
            textFieldProps={{
              placeholder: 'Pesquisar por nome do aluno…',
              variant: 'outlined',
              size: 'small',
              fullWidth: true,
            }}
          />
        </Box>

        {/* if you have any right‑side buttons, put them here */}
        {/* <Button onClick={…}>My Action</Button> */}
      </Box>
    )
  });

  return (
    <>
      <MaterialReactTable table={tableBasic} />
    </>
  );
};

export default TableHeaderCustom;